// extracted by mini-css-extract-plugin
module.exports = {"SearchList":"styles_SearchList__8sils","selectedArticleRoot":"styles_selectedArticleRoot__UTx2i"};